module.exports = "https://thumbor.subcdn.com/imageView2/minio-activity/engro-cleaner/sfm-logo.edaec35c.png";